import OrganisationProvider from "providers/OrganisationProvider";
import { useMemo, useCallback, useState } from "react";
import OrganisationService from "services/OrganisationService";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import UserContext from "../../contexts/UserContext";
import UserService from "../../services/UserService";

function UserProvider(props) {
  const [auth, setAuth] = useState({
    user: null,
    profile: null,
    organisation: null,
  });

  const getUser = useCallback(async (user) => {
    const [profile, organisation] = await Promise.all([UserService.getMe(), OrganisationService.get()]);

    setAuth((prevAuth) => ({ user: { ...prevAuth.user, ...user }, profile, organisation }));
  }, []);

  const onLoginSuccess = useCallback(
    async (user) => {
      await getUser(user);
      await UserService.setLastSeen();
    },
    [getUser]
  );

  const onUpdate = useCallback(
    (profile) => setAuth((prevAuth) => ({ ...prevAuth, profile: { ...prevAuth.profile, ...profile } })),
    []
  );

  const onSignOut = useCallback(async () => {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(`${LocalStorageHelper.keys.programInProgressWarningDismissed}:`))
      .forEach((key) => localStorage.removeItem(key));
    await UserService.signOut();
    setAuth({ user: null, profile: null, organisation: null });
  }, []);

  const onSetProfileImage = useCallback(
    async (photo) => {
      await UserService.setProfileImage(photo);
      await getUser();
    },
    [getUser]
  );

  const onDeleteProfileImage = useCallback(async () => {
    await UserService.deleteProfileImage();

    onUpdate({ profilePhotoUrl: null, profilePhotoName: null });
  }, [onUpdate]);

  const contextValue = useMemo(
    () => [auth, { onLoginSuccess, onUpdate, onSignOut, onSetProfileImage, onDeleteProfileImage }],
    [auth, onLoginSuccess, onUpdate, onSignOut, onSetProfileImage, onDeleteProfileImage]
  );

  const setOrganisation = useCallback((organisation) => {
    setAuth((prev) => ({
      ...prev,
      organisation: { ...prev.organisation, ...organisation },
    }));
  }, []);

  return (
    <UserContext.Provider value={contextValue}>
      <OrganisationProvider organisation={auth.organisation} setOrganisation={setOrganisation}>
        {props.children}
      </OrganisationProvider>
    </UserContext.Provider>
  );
}
export default UserProvider;
